<script setup lang="ts">
  import InputQC from '@qicgroupdoha/qic-connect-ds/components/InputQC'

  interface Props {
    modelValue: string | undefined
  }

  defineProps<Props>()
</script>

<template>
  <InputQC
    :model-value="modelValue"
    name="fullName"
    :label="$t('full_name_placeholder')"
    is-valid
    disabled
    :container-attrs="{ 'data-test': 'full-name-input' }"
    data-test="full-name-input-inner"
  />
</template>
